/**
 * @fileoverview The table a tabular KPI is answered in, read off its
 * stored `details` rows for the grid's Table setup cell.
 */

import { detailsToSchema } from "../../Questions Module/TableSchemaBuilder/schemaDetails";

const count = (n, noun) => `${n} ${noun}${n === 1 ? "" : "s"}`;

/**
 * One line describing a KPI's table, or "" when none is set up.
 *
 * @param {string} type question type
 * @param {object[]} details stored rows
 * @returns {string}
 */
export const tableSummary = (type, details) => {
  const schema = detailsToSchema(type, details);
  if (Array.isArray(schema)) return "";
  if (schema.type === "fully-dynamic") return "Dynamic rows · dynamic columns";
  if (schema.type === "dynamic") return `Dynamic rows · ${count(schema.columns.length, "column")}`;
  if (schema.mode === "same-columns") {
    return `${count(schema.rows.length, "row")} · ${count(schema.columns.length, "column")}`;
  }
  return `${count(schema.rows.length, "row")} · columns per row`;
};
